export default __webpack_public_path__ + "static/media/ic-close.00572f90.svg";